/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type AttachmentEntityTypeEnum = "contacts" | "containers" | "messages" | "shipments" | "%future added value";
export type infoUpdateEntityThumbnailInput = {
    clientMutationId?: string | null;
    attachmentSlug: string;
    entityType: AttachmentEntityTypeEnum;
    entitySlug: string;
};
export type EntityAttachmentListPreviewerThumbnailMutationVariables = {
    input: infoUpdateEntityThumbnailInput;
};
export type EntityAttachmentListPreviewerThumbnailMutationResponse = {
    readonly infoUpdateEntityThumbnail: {
        readonly clientMutationId: string | null;
    } | null;
};
export type EntityAttachmentListPreviewerThumbnailMutation = {
    readonly response: EntityAttachmentListPreviewerThumbnailMutationResponse;
    readonly variables: EntityAttachmentListPreviewerThumbnailMutationVariables;
};



/*
mutation EntityAttachmentListPreviewerThumbnailMutation(
  $input: infoUpdateEntityThumbnailInput!
) {
  infoUpdateEntityThumbnail(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoUpdateEntityThumbnailPayload",
    "kind": "LinkedField",
    "name": "infoUpdateEntityThumbnail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EntityAttachmentListPreviewerThumbnailMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EntityAttachmentListPreviewerThumbnailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "25090e68e9b650715784fd319c48a9e0",
    "id": null,
    "metadata": {},
    "name": "EntityAttachmentListPreviewerThumbnailMutation",
    "operationKind": "mutation",
    "text": "mutation EntityAttachmentListPreviewerThumbnailMutation(\n  $input: infoUpdateEntityThumbnailInput!\n) {\n  infoUpdateEntityThumbnail(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'f098cadb463cc681596dc073f2d71aa9';
export default node;
